"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var EmailExclusivesProductCards_1 = require("./EmailExclusivesProductCards");
var GridCrossSell = function (_a) {
    var products = _a.products;
    return ((0, preact_1.h)(preact_1.Fragment, null, products.length > 0 && ((0, preact_1.h)("div", { class: "grid-cross-sell__wrapper" },
        (0, preact_1.h)("p", { class: "grid-cross-sell__header" },
            (0, preact_1.h)("span", { class: "proxima-nova extrabold" },
                "Explore Our",
                (0, preact_1.h)("br", { class: "hide-on-desktop" }),
                " Products")),
        (0, preact_1.h)(EmailExclusivesProductCards_1.default, { isDesktop: false, products: products })))));
};
exports.default = GridCrossSell;
